<script setup lang="ts">
  import DownloadQRIcon from '@assets/icons/sidebar/download-qr-code.svg'
  import DownloadMiniIcon from '@assets/icons/sidebar/download-minified.svg'
  import DownloadStoresImage from '@assets/icons/sidebar/download-stores.svg?url'

  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()

  const { mobile, collapsed } = defineProps<{
    mobile: boolean,
    collapsed: boolean
  }>()

</script>

<template>
  <v-col class="px-4">
    <v-btn
      v-if="mobile || !collapsed"
      v-track="{event: 'download_app_banner_clicked', eventData: {source: 'side menu'}}"
      class="py-3 ps-3 pe-4 bg-primary rounded-lg w-100 d-flex justify-start"
      height="auto"
      href="https://asksina.short.gy/SideMenu"
      target="_blank"
    >
      <div class="pa-0 text-white flex-grow-1">
        <p class="text-body-2 font-weight-bold mb-1">{{ t('download_app_now') }}</p>
        <p class="text-body-2 font-weight-medium">{{ t('download_app_now_subtitle') }}</p>
      </div>

      <template #append>
        <v-icon
          v-if="!mobile"
          class="flex-shrink-0 rounded-sm overflow-hidden"
          :icon="DownloadQRIcon"
          size="64"
        />
        <v-img
          v-else
          class="flex-shrink-0"
          cover
          height="69"
          :src="DownloadStoresImage"
          width="97"
        />
      </template>
    </v-btn>
    <v-btn
      v-else
      class="pa-2 bg-primary d-flex justify-center align-center rounded-lg"
      size="36"
    >
      <v-icon class="flex-shrink-0" :icon="DownloadMiniIcon" size="20" />
    </v-btn>
  </v-col>
</template>

<style scoped lang="scss">
:deep(.v-btn__content) {
  flex-grow: 1;
  display: flex;

  p {
    max-width: 150px;
    white-space: wrap;
  }
}

</style>
